const StoryActionTypes = {
  SET_STORIES_LIST: "SET_STORIES_LIST",
  SET_STORY_DATA: "STORIES_SET_STORY_DATA",
  RESET: "STORIES_RESET",
  STORY_IS_OPEN: "STORY_IS_OPEN"
};

export default StoryActionTypes;
